import { Button, Grid, Switch } from "@mui/material";
import SoftBox from "components/SoftBox";
import React, { useState } from "react";
import { useAgencyInfo } from "context/agency";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import env from "config";
import SoftTypography from "components/SoftTypography";
import FormField from "layouts/pages/account/components/FormField";
import { useUploadImage } from "hook/services";

function ProfileSettings({ loading, handelThemeData, selectedTheme }) {
  const inputData = selectedTheme?.theme_data?.general;
  const [agency,Update] = useAgencyInfo();
  const customUrlDomain = env.ACCOUNT_LEVEL_URL;
  const SERVER_IP = env.SERVER_IP;

  const [openWhitelabelModal, setopenWhitelabelModal] = useState(false);

  const url = inputData?.domain
    ? `https://${agency.domain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`
    : `${customUrlDomain}/{{user.email}}/{{location.id}}/app/home?sessionKey={{user.sessionKey}}`;

  const handleSubmit = async (e, val) => {
    e.preventDefault();

    const form = e.target;
    const formData = new FormData(form);
    const formObject = {};
    formData.forEach((value, key) => {
      formObject[key] = value;
    });

    if (val) {
      formObject.extraValue = val;
    }
    const updatedGeneral = { ...selectedTheme?.theme_data?.general, ...formObject };

    handelThemeData({
      ...selectedTheme?.theme_data,
      general: updatedGeneral,
      profile: formObject
    });

    Update({
      profile: {
        ...agency.profile,
        ...formObject,
      },
    });
  };

  return (
    <div>
      <SoftBox component="form" onSubmit={(e) => handleSubmit(e, "someValue")}>
        <Grid container spacing={3} rowSpacing={2} paddingX={3} paddingBottom={4}>
          <Grid item xs={12} className="zeroBtmP">
            <SoftTypography variant="h5">Customer Info</SoftTypography>
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <FormField
              label="Email"
              placeholder="example@email.com"
              inputProps={{ type: "email" }}
              name="email"
              defaultValue={agency?.profile?.email || "email@smartdirectory.ai"}
            />
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <SoftTypography
              component="label"
              variant="caption"
              fontWeight="bold"
              textTransform="capitalize"
            >
              Name
            </SoftTypography>
            <SoftInput
              label="Name"
              placeholder="Enter Name"
              inputProps={{ type: "name" }}
              name={"name"}
              defaultValue={agency?.profile?.name || "Smart Directory"}
            />
          </Grid>
          <Grid item xs={12} sm={4} className="px-2">
            <FormField
              label="Phone Number"
              placeholder="(555) 123-4567"
              inputProps={{ type: "phone" }}
              name={"phone_number"}
              defaultValue={agency?.profile?.phone_number || "(555) 123-4567"}
            />
          </Grid>

          <Grid item xs={12} className="zeroBtmP" style={{ marginTop: "20px" }}>
            <SoftTypography variant="h5">Social Links</SoftTypography>
          </Grid>
          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Facebook"
              placeholder="Facebook"
              name="facebook"
              defaultValue={agency?.profile?.facebook}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Instagram"
              placeholder="Instagram"
              name="instagram"
              defaultValue={agency?.profile?.instagram}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="LinkedIn"
              placeholder="LinkedIn"
              name="linkedin"
              defaultValue={agency?.profile?.linkedin}
            />
          </Grid>
          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Twitter"
              placeholder="Twitter"
              name="twitter"
              defaultValue={agency?.profile?.twitter}
            />
          </Grid>

          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Contact Us"
              placeholder="Contact Us"
              name="contact_us"
              defaultValue={agency?.profile?.contact_us}
            />
          </Grid>

          <Grid item xs={6} Soft={6} className="px-2">
            <FormField
              label="Learn More"
              placeholder="Learn More"
              name="learn_more"
              defaultValue={agency?.profile?.learn_more}
            />
          </Grid>

          <Grid item xs={12} className="px-2" display="flex" justifyContent={"end"}>
            <button className="btn-new-design-black" disabled={loading} type="submit">
              Update
            </button>
          </Grid>
          {openWhitelabelModal && (
            <div className="modal-zz-confirm" onClick={() => setopenWhitelabelModal(false)}>
              <div
                className="scrollable-modal-content bg-white  rounded"
                style={{ border: "1px solid black ", position: "relative" }}
              >
                <h2 className="text-center font-14"> Connect white label domain</h2>
                <span className="crossison">X</span>
                <div className="list-model0">
                  <p>
                    Connect your own domain to the system (without https://)
                    maybetech.yourdomain.com
                  </p>
                  <p>
                    {" "}
                    You can use any domain you own or you can create a sub-domain like
                    maybetech.yourdomain.com to get white-labeled access to the platform.
                  </p>
                  <ul>
                    <li className="listtext">
                      <b>1.</b> Refer to your domain registrar&apos;s control panel, choose desired
                      domain zone.
                    </li>

                    <li className="listtext">
                      {" "}
                      <b>2.</b>Create a record of{" "}
                      <u>
                        <b>ANAME</b>
                      </u>{" "}
                      type, enter your domain/subdomain name and point it to{" "}
                      <u>
                        <b>{SERVER_IP}</b>
                      </u>{" "}
                    </li>
                    <li className="listtext">
                      {" "}
                      <b>3.</b> We will do the rest!{" "}
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          )}
        </Grid>
      </SoftBox>
    </div>
  );
}

export default ProfileSettings;
